import { DataTable, STATUSPAGE } from '@repo/ui';
import { useEntities } from 'presentation/app/modules/Entities/hooks/useEntities';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Row,
  Spinner,
} from 'reactstrap';

import { makeColumnsFieldAssessments } from './columns/columns-field-assessments';
import { ModalEditFieldAssessments } from './components/modal-edit-field-assessments';

interface IProps {
  controller: ReturnType<typeof useEntities>;
}

export const FieldAssessments = ({ controller }: IProps) => {
  const { entityId } = useParams<{ entityId: string }>();

  const noDataConfig = {
    noDataTitle: 'Nenhuma questão encontrada',
    noDataDescription: 'Não há questões cadastradas no momento.',
  };

  const {
    isModalFieldAssessmentsOpen,
    toggleModalFieldAssessments,
    requestCreateFieldAssessments,
    requestGetAllFieldAssessments,
    requestDeleteFieldAssessments,
    requestGetByIdFieldAssessments,
    validationFieldAssessments,
    loadingStates,
    listFieldAssessments,
  } = controller;

  useEffect(() => {
    requestGetAllFieldAssessments({ id: entityId });
  }, [entityId]);

  return (
    <Card className="mt-5">
      <ModalEditFieldAssessments
        isOpen={isModalFieldAssessmentsOpen}
        toggleModal={toggleModalFieldAssessments}
        loadingFieldAssessments={loadingStates}
        validationFieldAssessments={validationFieldAssessments}
      />
      <Form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          validationFieldAssessments.handleSubmit();
          return false;
        }}
      >
        <CardBody>
          <Row className="align-items-center mb-3">
            <Col xs={12} md={10}>
              <Input
                id="name"
                name="name"
                type="text"
                className="form-control"
                onBlur={validationFieldAssessments.handleBlur}
                value={validationFieldAssessments?.values?.name}
                onChange={validationFieldAssessments.handleChange}
                placeholder="Nova Questão da Avaliação de Campo"
              />
            </Col>
            <Col xs={12} md={2} className="d-flex justify-content-end">
              <Button
                onClick={() => {
                  requestCreateFieldAssessments({
                    name: validationFieldAssessments.values.name,
                    organizationId: entityId,
                  });
                }}
                disabled={
                  !validationFieldAssessments.values.name ||
                  loadingStates.createFieldAssessments === STATUSPAGE.LOADING
                }
                color="primary"
                className="w-100"
              >
                {loadingStates.createFieldAssessments ===
                  STATUSPAGE.LOADING && <Spinner size="sm" className="me-2" />}
                Adicionar
              </Button>
            </Col>
          </Row>

          <DataTable
            noDataTitle={noDataConfig.noDataTitle}
            noDataDescription={noDataConfig.noDataDescription}
            actions={[
              {
                id: 1,
                name: 'Editar',
                label: 'Editar',
                onPress: (field) => {
                  requestGetByIdFieldAssessments({ id: field.id });
                },
                classNameColorIcon: 'primary',
                nameFeatherIcon: 'edit',
              },
            ]}
            loading={
              loadingStates.getAllFieldAssessments === STATUSPAGE.LOADING
            }
            canSearch={false}
            columns={makeColumnsFieldAssessments()}
            pagination={false}
            data={listFieldAssessments}
            handleDelete={(id) => {
              requestDeleteFieldAssessments({
                id,
              });
            }}
          />
        </CardBody>
      </Form>
    </Card>
  );
};
